import { supabase } from '../supabase';
import { DEFAULT_CONFIG } from './dateUtils';

/**
 * Global calculation settings, stored in app_config (key 'calc_settings').
 * The DB row is the source of truth (allocation buffers are company policy,
 * not personal preference); localStorage is only a synchronous read cache so
 * the existing loadSettings() call sites keep working unchanged.
 */
const STORAGE_KEY = 'supplyRoundUp_settings';

export async function syncGlobalConfig() {
  try {
    const { data, error } = await supabase
      .from('app_config')
      .select('value')
      .eq('key', 'calc_settings')
      .maybeSingle();
    if (error || !data?.value) return null;
    const merged = { ...DEFAULT_CONFIG, ...data.value };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    window.dispatchEvent(new Event('calc-settings-updated'));
    return merged;
  } catch {
    return null;
  }
}

/** Synchronous read of the cached settings (same key loadSettings uses). */
export function loadCalcSettings() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return { ...DEFAULT_CONFIG, ...JSON.parse(stored) };
  } catch { /* fall through */ }
  return { ...DEFAULT_CONFIG };
}

/** Admin-only (RLS enforced). Non-admin writes fail silently → local-only. */
export async function saveGlobalConfig(settings) {
  try {
    const { data: userData } = await supabase.auth.getUser();
    const { error } = await supabase.from('app_config').upsert({
      key: 'calc_settings',
      value: settings,
      updated_at: new Date().toISOString(),
      updated_by: userData?.user?.email || 'unknown',
    });
    return !error;
  } catch {
    return false;
  }
}
